import { render } from "./ListPage.vue?vue&type=template&id=a402dc0c&ts=true"
import script from "./ListPage.vue?vue&type=script&lang=ts"
export * from "./ListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__